import { Box, Button, Radio } from '@mui/material'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import Datepicker from '../../../common/datePicker'
import DropDownOA from '../../../common/dropDownOA'
import { appendToUrl, focusElemnt, isEmpty } from '../../../common/helper'
import { modeAllPayments, paymentModesWithAll } from '../../../common/paymentsMode'
import { Item } from '../../../common/snippets'
import { SplitButton } from '../../../common/SplitButton'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { RefreshSvg } from '../../../common/svg/refresh'
import { ReportHeading } from '../common/ReportHeading'
import * as id from '../reportId'
import * as lb from '../reportLables'
import { getOwnChildUsers, getFranchiseeBranchList, getCompanyList } from '../../../../store/reports/reports_action'
import * as urls from '../oldReportsUrls'
import { userAll } from '../../../common/constants'
import DeliveryOwnCompany from './DeliveryOwnCompany/DeliveryOwnCompany'
import DeliveryFranchiseeCompany from './DeliveryFranchiseeCompany/DeliveryFranchiseeCompany'
import DeliveryOwnCompanyNew from './DeliveryOwnCompany/DeliveryOwnCompanyNew'
import DeliveryFranchiseeCompanyNew from './DeliveryFranchiseeCompany/DeliveryFranchiseeCompanyNew'
const DeliveryReport = (props) => {
  const {
    data: { common, reports },
    getOwnChildUsers,
    getFranchiseeBranchList,
  } = props
  const { loginData } = common
  const { ownChildBranches, ownChildUsers, franchiseeCompany, franchiseeBranches } = reports
  const [selCompany, setSelCompany] = useState(false)
  const [selPaymentTpe, setSelPaymentType] = useState(modeAllPayments)
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [selectedRadio, setSelectedRadio] = useState('OwnCompany')
  const [selBranch, setSelBranch] = useState()
  const [selUser, setSelUser] = useState(userAll)
  const [selFrCompany, setSelFrCompany] = useState()
  const [selFrBranch, setSelFrBranch] = useState()
  useEffect(() => {
    if (!isEmpty(loginData)) {
      const branchData = {
        intCompanyID: loginData.intCompanyID,
        intIsActive: -1,
      }
      setSelBranch({ BranchName: loginData.strBranchName, BranchID: loginData.intBranchID })
      getOwnChildUsers(branchData)
      const companylistData = {
        intCompanyID: loginData.intCompanyID,
        intUserID: loginData.intUserID,
        intMode: 1,
      }
      getCompanyList(companylistData)
    }
  }, [loginData])
  useEffect(() => {
    if (franchiseeCompany && franchiseeCompany.length) {
      setSelFrCompany(franchiseeCompany[0])
      getFranchiseeBranch(franchiseeCompany[0])
    }
  }, [franchiseeCompany])

  const getFranchiseeBranch = (company) => {
    const data = {
      intCompanyID: loginData.intCompanyID,
      intUserID: loginData.intUserID,
      intFranchiseeCompanyID: company.CompanyID,
    }
    getFranchiseeBranchList(data)
  }
  const handleClick1 = () => {
    let url = urls.deliveryReport
    let urlData = urls.deliveryReportParams
    urlData.chk = loginData.BusCrsCheckSum
    urlData.intCompanyID = loginData.intCompanyID
    urlData.intBranchID = loginData.intBranchID
    urlData.intUserID = selUser.UserID
    urlData.dtFromDate = fromDate.format('DD-MMM-YYYY')
    urlData.dtToDate = toDate.format('DD-MMM-YYYY')
    urlData.intPaymentType = selPaymentTpe.typeId
    urlData.PaymentType = selPaymentTpe.type
    urlData.BookedByBranch = selBranch.BranchID
    if (selectedRadio === 'OwnCompany') {
      urlData.intAllowExportToExcel = 1
    }
    if (selectedRadio === 'FranchiseCompany') {
      urlData.intFranchCompanyID = selFrCompany?.CompanyID
      urlData.intFranchBranchID = selFrBranch?.BranchID || 0
      urlData.FranchiseeCompany = selFrCompany?.CompanyName
      urlData.FranchiseeBranch = selFrBranch?.BranchName
    }
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
    // console.log(urlData)
  }

  const reportName = 'Delivery'
  const handleChange = (e) => {
    setSelectedRadio(e.target.value)
    focusElemnt(id.fromDate)
  }
  return (
    <>
    <Box sx={{ padding: '0',gap:'15px' }} className="reports" style={{}}>
      <ReportHeading reportName={reportName} />
      <Box className="radio-wrap" sx={{ paddingLeft: '15px', paddingRight: '24px', display: 'flex',borderBottom:'1px solid #ccc !important',fontSize:'14px',gap:"16px"}}>
        <label htmlFor={'isCrossingRadioYes'} className="radio-label flex">
          <Radio
            id={'isCrossingRadioYes'}
            name={`isCrossingRadio`}
            size={'medium'}
            value="OwnCompany"
            checked={selectedRadio === 'OwnCompany'}
            onChange={handleChange}
          />
          OWN DELIVERIES
        </label>
          <label htmlFor={'isCrossingRadioNo'} className="radio-label flex">
            <Radio
              id={'isCrossingRadioNo'}
              name={`isCrossingRadio`}
              size={'medium'}
              value="FranchiseCompany"
              checked={selectedRadio === 'FranchiseCompany'}
              onChange={handleChange}
            />
            Franchisee Deliveries
          </label>
      </Box>
      {/* <Box sx={{ ...sx.reportFlex, justifyContent: 'start' }}>
        <Item sx={sx.itemsxGrow}>
          <DropDownOA
            id={id.selectCompnay}
            label={lb.select_company}
            defaultvalue={loginData.strCompanyName}
            disabled={true}
            onSelect={(val) => setSelCompany(val)}
            width="100%"
          />
        </Item>
        <Item sx={sx.itemsx} className="disabled-wrapper">
          <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary">
            GO
          </Button>
        </Item>
        <Item sx={sx.itemsx} className="input--container bookingDatePicker">
          <Datepicker
            name={'from_date'}
            label={`From Delivery Date`}
            id={id.fromDate}
            dateChange={(date) => {
              setFromDate(date)
              focusElemnt(id.toDate)
            }}
            width="100%"
          />
        </Item>
        <Item sx={sx.itemsx} className="input--container bookingDatePicker">
          <Datepicker
            name={'to_date'}
            label={'To Delivery  Date'}
            id={id.toDate}
            dateChange={(date) => {
              setToDate(date)
              focusElemnt(id.selBranch)
            }}
            width="100%"
          />
        </Item>
        <Item sx={sx.itemsxGrow}>
          <DropDownOA
            label={`Branch`}
            id={id.selBranch}
            data={ownChildBranches || []}
            defaultvalue={loginData.strBranchName}
            dataKey={`BranchName`}
            idKey={`BranchID`}
            onSelect={(branch) => {
              setSelBranch(branch)
            }}
            width="100%"
            nextId={id.paymentBookingType}
            prevId={id.fromDate}
          />
        </Item>
        <Item sx={sx.itemsxGrow}>
          <DropDownOA
            id={id.paymentBookingType}
            label={lb.paymentType}
            isObjArr={true}
            onSelect={(val) => {
              setSelPaymentType(val)
            }}
            data={paymentModesWithAll || []}
            dataKey={`name`}
            idKey={`typeId`}
            defaultvalue={modeAllPayments.name}
            nextId={id.userLIst}
            prevId={id.selBranch}
            width="100%"
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            id={id.userLIst}
            label={lb.user}
            defaultvalue={userAll.UserName}
            value={selUser.UserName}
            data={[userAll, ...ownChildUsers.filter((e) => e.BranchID === selBranch?.BranchID)]}
            dataKey={`UserName`}
            idKey={`UserID`}
            onSelect={(obj) => setSelUser(obj)}
            nextId={selectedRadio === 'FranchiseCompany' ? id.franchiseCompany : id.reportmainButton}
            prevId={id.selBranch}
          />
        </Item>

        {selectedRadio === 'FranchiseCompany' ? (
          <>
            <Item sx={sx.itemsx}>
              <DropDownOA
                id={id.franchiseCompany}
                label={lb.franchiseCompany}
                defaultvalue={selFrCompany?.CompanyName || ''}
                value={selFrCompany?.CompanyName || ''}
                data={franchiseeCompany}
                onSelect={(company) => {
                  setSelFrCompany(company)
                  getFranchiseeBranch(company)
                }}
                dataKey={`CompanyName`}
                idKey={`CompanyID`}
                nextId={id.franchiseBranch}
                prevId={id.userLIst}
              />
            </Item>
            <Item sx={sx.itemsx}>
              <DropDownOA
                id={id.franchiseBranch}
                label={lb.franchiseBranch}
                data={franchiseeBranches}
                dataKey={`BranchName`}
                onSelect={(branch) => {
                  setSelFrBranch(branch)
                }}
                idKey={`BranchID`}
                nextId={id.reportmainButton}
                prevId={id.franchiseCompany}
              />
            </Item>
          </>
        ) : (
          ''
        )}
        <Item sx={sx.itemsx}>
          <SplitButton
            options={['GENERATE OLD FORMAT', 'GENERATE NEW FORMAT']}
            hideToggle={true}
            id1={id.reportmainButton}
            onClick1={handleClick1}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, display: 'none' }}>
          <RefreshSvg />
        </Item>
      </Box> */}
    </Box>
    {
      selectedRadio === 'OwnCompany'?<DeliveryOwnCompanyNew/>:<DeliveryFranchiseeCompanyNew/>
    }
    
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getOwnChildUsers, getFranchiseeBranchList }
export default connect(mapStateToProps, mapDispatchToProps)(DeliveryReport)
